import { Button } from '@mui/material';
import { createLink } from '@tanstack/react-router';

const NavButton = createLink(Button);

export default NavButton;
